import RecentNotifications from './RecentNotifications'

export default RecentNotifications
